"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _ItemPipes = _interopRequireDefault(require("./ItemPipes"));
var _useGetComponentsByParams = require("../../../hooks/store/useGetComponentsByParams");
var _Device = _interopRequireDefault(require("../Models/Device"));
var _HotSpotBox = _interopRequireDefault(require("../Models/HotSpotBox"));
var _models = require("../../models");
var _constants = require("../../../utils/constants");
var _selectors = require("../../../redux/selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  ComponentTypes,
  LoopType,
  SectionTypes,
  sensorTypes
} = _paulCorePackage.constants;
const Item = exports.Item = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    supplyId = '',
    isFirst = false,
    isLast = false,
    isSerial = false,
    hasCirculation = false,
    position = [0, 0, 0]
  } = _ref;
  const type = ComponentTypes.PwhSupply;
  const hasPwhC = (0, _reactRedux.useSelector)((0, _selectors.selectStructureShowModelByType)(_constants.TypesByDep.PwhC));
  const {
    thingPwhSupplyDeviceType: {
      id: pwhSupTypeKey = null
    } = {}
  } = (0, _useGetComponentsByParams.useGetComponentByTypeAndId)({
    type,
    id: supplyId
  }) || {};
  // const {thingPwhSupplyDeviceType: { id: pwhSupTypeKey = null } = {}} = {thingPwhSupplyDeviceType: { id: null, value: {}}};
  const showBox = false;
  if (pwhSupTypeKey == null) console.log("".concat(type, ":thingPwhSupplyDeviceTypeId = ").concat(pwhSupTypeKey));
  const isKey = key => Number(pwhSupTypeKey) === key;
  return /*#__PURE__*/_react.default.createElement("group", {
    position: position,
    dispose: null,
    visible: true
  }, /*#__PURE__*/_react.default.createElement("group", {
    position: [0, 0, 0]
  }, /*#__PURE__*/_react.default.createElement(_ItemPipes.default, {
    position: [0, 0, 0],
    thingPwhSupplyDeviceTypeKey: pwhSupTypeKey,
    hasCirculation: hasCirculation,
    hasPwhC: hasPwhC,
    isFirst: isFirst,
    isLast: isLast,
    isSerial: isSerial
  }), pwhSupTypeKey ? /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, _constants.verticalPipeSpacing * (hasCirculation ? 3 : 2), -6],
    showBox: showBox,
    pipe: _constants.pipesTypes.hotWater
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: supplyId,
    thingLoopType: LoopType.none,
    thingSectionType: SectionTypes.none
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, _constants.verticalPipeSpacing * 2, -6],
    showBox: showBox,
    pipe: _constants.pipesTypes.circulation,
    visible: hasCirculation && hasPwhC
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: supplyId,
    thingLoopType: LoopType.none,
    thingSectionType: SectionTypes.circulation,
    modelProps: {
      [sensorTypes.smartValve]: {
        deviceRotate: [-Math.PI / 2, -Math.PI / 2, 0]
      }
    }
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [isSerial && !isFirst ? 20.5 : 0, _constants.verticalPipeSpacing, -39],
    showBox: showBox,
    visible: !isKey(_constants.pwhSupConfig.freshWater),
    pipe: isKey(_constants.pwhSupConfig.storeCharging) ? _constants.pipesTypes.chilledWater : _constants.pipesTypes.heatingReturn
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: supplyId,
    thingLoopType: LoopType.none,
    thingSectionType: SectionTypes.return
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, _constants.verticalPipeSpacing * 2, -39],
    showBox: showBox,
    visible: !isKey(_constants.pwhSupConfig.freshWater),
    pipe: isKey(_constants.pwhSupConfig.storeCharging) ? _constants.pipesTypes.hotWater : _constants.pipesTypes.heatingFlow
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: supplyId,
    thingLoopType: LoopType.none,
    thingSectionType: SectionTypes.flow
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 15, -35],
    args: [3, 15, 6],
    showBox: showBox,
    visible: isKey(_constants.pwhSupConfig.freshWater)
  }, /*#__PURE__*/_react.default.createElement(_models.HeatExchangerModel, {
    position: [0, 5, 0]
  })), /*#__PURE__*/_react.default.createElement("group", {
    visible: !isKey(_constants.pwhSupConfig.freshWater)
  }, /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, _constants.verticalPipeSpacing, -33],
    scale: [1, 1, 0.8],
    rotation: [0, 0, 0],
    visible: isSerial ? isFirst : true,
    highlightsType: isKey(_constants.pwhSupConfig.hotWater) ? _constants.pipesTypes.heatingReturn : _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, _constants.verticalPipeSpacing * 2, -33],
    scale: [1, 1, 0.8],
    rotation: [0, 0, 0],
    highlightsType: isKey(_constants.pwhSupConfig.hotWater) ? _constants.pipesTypes.heatingFlow : _constants.pipesTypes.hotWater
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 17.5, -25],
    args: [14.5, 35, 14.5],
    showBox: showBox,
    visible: !isKey(_constants.pwhSupConfig.freshWater)
  }, /*#__PURE__*/_react.default.createElement(_models.StorageWaterHeater, {
    position: [0, -7.5, 0]
  }))) : /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, _constants.verticalPipeSpacing, -33],
    scale: [1, 1, 0.8],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, _constants.verticalPipeSpacing * 2, -33],
    scale: [1, 1, 0.8],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.hotWater
  }))));
}, function () {
  let prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return prev.supplyId === next.supplyId && prev.isFirst === next.isFirst && prev.isLast === next.isLast && prev.isSerial === next.isSerial && prev.hasCirculation === next.hasCirculation && prev.position === next.position;
});